(function () {
  'use strict';

  var endpoint = 'https://gefcompany.app.n8n.cloud/webhook/form-confirm';
  var messages = {
    name: 'Inserisci il tuo nome',
    email: 'Email non valida (es. nome@azienda.it)',
    phone: 'Inserisci un numero di telefono valido',
    vat: 'P.IVA non valida (prefisso paese opzionale, 6-15 cifre)'
  };

  function installStyles() {
    if (document.getElementById('gef-contact-form-runtime-styles')) return;
    var style = document.createElement('style');
    style.id = 'gef-contact-form-runtime-styles';
    style.textContent =
      '.gef-form-field-error{display:block;margin-top:6px;color:#9b1c1c;font-size:13px;line-height:1.35}' +
      '@media(max-width:749px){form[action*="/contact"] input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]),' +
      'form[action*="/contact"] select,form[action*="/contact"] textarea,form[action*="/contact"] button{font-size:16px!important}}';
    document.head.appendChild(style);
  }

  function fieldKind(field) {
    var raw = ((field.getAttribute('name') || '') + ' ' + (field.id || '') + ' ' + (field.getAttribute('autocomplete') || '')).toLowerCase();
    if (raw.indexOf('email') !== -1) return 'email';
    if (raw.indexOf('phone') !== -1 || raw.indexOf('tel') !== -1 || raw.indexOf('telefono') !== -1) return 'phone';
    if (raw.indexOf('vat') !== -1 || raw.indexOf('iva') !== -1 || raw.indexOf('partita') !== -1 || raw.indexOf('piva') !== -1) return 'vat';
    if (raw.indexOf('name') !== -1 || raw.indexOf('nome') !== -1) return 'name';
    return '';
  }

  function errorNode(field) {
    var selector = '[data-gef-field-error-for="' + String(field.name).replace(/"/g, '\\"') + '"]';
    var node = field.parentElement && field.parentElement.querySelector(selector);
    if (!node && field.parentElement) {
      node = document.createElement('small');
      node.className = 'gef-form-field-error';
      node.setAttribute('data-gef-field-error-for', field.name);
      node.setAttribute('aria-live', 'polite');
      field.insertAdjacentElement('afterend', node);
    }
    return node;
  }

  function syncError(field) {
    var node = errorNode(field);
    if (!node) return;
    var kind = fieldKind(field);
    var msg = field.validationMessage;
    if (field.validity.valueMissing && kind === 'name') msg = messages.name;
    if ((field.validity.typeMismatch || field.validity.valueMissing) && kind === 'email') msg = messages.email;
    if ((field.validity.patternMismatch || field.validity.valueMissing) && kind === 'phone') msg = messages.phone;
    if (field.validity.patternMismatch && kind === 'vat') msg = messages.vat;
    node.textContent = field.validity.valid ? '' : msg;
    field.setAttribute('aria-invalid', field.validity.valid ? 'false' : 'true');
  }

  function addHidden(form, name, value) {
    var existing = form.querySelector('[name="' + name + '"]');
    if (existing) {
      if (value && !existing.value) existing.value = value;
      return existing;
    }
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
    return input;
  }

  function makeSubmissionId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'gef-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
  }

  function safeFormId(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9-]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 48) || 'pagina';
  }

  installStyles();
  var forms = Array.prototype.slice.call(document.querySelectorAll('form[action*="/contact"]'));
  var seenIds = Object.create(null);

  forms.forEach(function (form, index) {
    var isNewsletter = !!form.querySelector('[name="klaviyo_list"], [name="contact[accepts_marketing]"]');
    var previousId = form.id || '';
    var candidateId = previousId || 'gef-' + (isNewsletter ? 'newsletter' : 'contact') + '-' + safeFormId(window.location.pathname) + '-' + (index + 1);
    if (seenIds[candidateId]) {
      candidateId = 'gef-' + (isNewsletter ? 'newsletter' : 'contact') + '-' + safeFormId(window.location.pathname) + '-' + (index + 1);
    }
    seenIds[candidateId] = true;
    if (form.id !== candidateId) {
      form.id = candidateId;
      var action = form.getAttribute('action') || '';
      if (previousId && action.slice(-(previousId.length + 1)) === '#' + previousId) {
        form.setAttribute('action', action.slice(0, -(previousId.length + 1)) + '#' + candidateId);
      }
    }

    if (isNewsletter) return;

    addHidden(form, 'contact[form_page]', window.location.pathname);
    addHidden(form, 'contact[form_id]', form.id);
    var submissionIdField = addHidden(form, 'contact[submission_id]', makeSubmissionId());

    form.querySelectorAll('input:not([type="hidden"]), select, textarea').forEach(function (field) {
      if (!field.name || field.disabled) return;
      field.addEventListener('invalid', function () { syncError(field); });
      field.addEventListener('blur', function () { syncError(field); });
      field.addEventListener('input', function () { syncError(field); });
      field.addEventListener('change', function () { syncError(field); });
    });

    form.addEventListener('submit', function () {
      var email = form.querySelector('[name="contact[email]"]');
      if (!email || !email.value || !form.checkValidity()) return;

      var submissionId = submissionIdField.value || makeSubmissionId();
      submissionIdField.value = submissionId;
      if (form.getAttribute('data-gef-capture-sent') === submissionId) return;
      form.setAttribute('data-gef-capture-sent', submissionId);

      var payload = {};
      new FormData(form).forEach(function (value, key) {
        if (Object.prototype.hasOwnProperty.call(payload, key)) {
          if (!Array.isArray(payload[key])) payload[key] = [payload[key]];
          payload[key].push(value);
        } else {
          payload[key] = value;
        }
      });
      payload.form_id = form.id;
      payload.submission_id = submissionId;
      payload.page = window.location.pathname;
      payload.submitted_at = new Date().toISOString();

      try {
        window.fetch(endpoint, {
          method: 'POST',
          mode: 'cors',
          credentials: 'omit',
          keepalive: true,
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
          body: JSON.stringify(payload)
        }).catch(function () {
          // Il submit nativo Shopify resta la seconda rete di sicurezza.
        });
      } catch (error) {
        // Il sidecar non deve mai bloccare il submit nativo Shopify/hCaptcha.
      }
    }, { capture: true });
  });
})();
